/* ==========================================================================
   tapanda-boot.js
   Deferred startup helpers extracted from layout/theme.liquid (Wave 1).

   Two IIFEs:
     1) tapandaRemoveFomoWidgets  — purges legacy FOMO/notification injections
                                    that some apps still try to mount.
     2) tapandaPremiumReveal      — IntersectionObserver-based fade/slide-up
                                    for `.wow` elements (replaces WOW.js).

   Anything that must run synchronously in <head> (cart-redirect guard,
   Liquid-templated globals like window.routes / DT_THEME / cartStrings)
   intentionally stays inline in layout/theme.liquid.
   ========================================================================== */
(function tapandaRemoveFomoWidgets() {
  var selectors = [
    '.customer-who-purchased',
    '[data-recommendation-widget]',
    '.tp-fomo-inline',
    '.fomo-widget',
    '.fomo-notification',
    '.fomo-popup'
  ];

  function purge(root) {
    root = root || document;
    for (var i = 0; i < selectors.length; i += 1) {
      if (root.nodeType === 1 && root.matches(selectors[i])) {
        root.remove();
        return;
      }

      if (!root.querySelectorAll) continue;
      var nodes = root.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j += 1) {
        if (nodes[j] && nodes[j].remove) {
          nodes[j].remove();
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', purge, { once: true });
  } else {
    purge();
  }

  if (typeof MutationObserver === 'function') {
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i += 1) {
        var addedNodes = records[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j += 1) {
          purge(addedNodes[j]);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }
})();

(function tapandaPremiumReveal() {
  function init() {
    var revealElements = document.querySelectorAll('.wow');
    if (revealElements.length === 0) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.style.setProperty('animation-delay', '0s', 'important');
          entry.target.style.setProperty('transition-delay', '0s', 'important');
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0, rootMargin: '0px 0px 24% 0px' });

      revealElements.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top <= window.innerHeight * 0.98) {
          el.classList.add('is-visible');
          return;
        }
        observer.observe(el);
      });
    } else {
      revealElements.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
